import GuaranteedReservationModalContainer from './GuaranteedReservationModalContainer';

export default GuaranteedReservationModalContainer;
